module.exports = __webpack_public_path__ + "img/num3.525b4adf.png";